export default {
  placeholders: {
    first_name: 'Nome',
    last_name: 'Cognome',
    email: 'Email',
    mobile_number: 'Numero di cellulare',
  },
  labels: {
    exclusive_offers_via_email: 'Vorrei ricevere offerte esclusive e novità via email.',
  },
  buttons: {
    sign_up: 'Registrati',
  },
};
